import type { CountryId } from '@indutrust/shared-model';
import { CountryIds } from '@indutrust/shared-model';
import { isValidCountryId } from '../country';

/**
 * Map of {@link CountryId} to international dial code prefixes.
 *
 * Keys are values from {@link CountryIds} and values are E.164 dial code strings.
 * @example
 * COUNTRY_DIAL_CODE_MAP[CountryIds.UAE] // "+971"
 */
const COUNTRY_DIAL_CODE_MAP: Record<CountryId, string> = {
  [CountryIds.UAE]: '+971',
  [CountryIds.KSA]: '+966',
  [CountryIds.Oman]: '+968',
  [CountryIds.Qatar]: '+974',
  [CountryIds.Kuwait]: '+965',
  [CountryIds.Bahrain]: '+973',
};

/**
 * Get the international dial code for a given country id.
 *
 * Validates the input and returns the corresponding E.164 prefix.
 *
 * @param countryId The numeric country id. Will be type-narrowed to {@link CountryId} if valid.
 * @returns The dial code (e.g., "+971") or `undefined` if the id is invalid.
 * @example
 * getDialCodeByCountryId(CountryIds.UAE) // "+971"
 */
export function getDialCodeByCountryId(countryId: number): string | undefined {
  return isValidCountryId(countryId)
    ? COUNTRY_DIAL_CODE_MAP[countryId]
    : undefined;
}
